module.exports = __webpack_public_path__ + "static/media/undraw_my_location@3x.6cfcaa90.png";